
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/[username]/board",
      function () {
        return require("private-next-pages/profile/[username]/board/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/[username]/board"])
      });
    }
  